import { EditableTagListCell as OasisEditableTagListCell } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";

export interface EditableTagListCellValue {
  values: string[];
  placeholder?: string;
  emptyLabel?: string;
  /** Case-insensitive dedupe by default. */
  caseInsensitiveDedupe?: boolean;
  disabled?: boolean;
  /** Cap how many tags are visible before collapsing into a "+N more" affordance. */
  maxVisibleTags?: number;
}

interface EditableTagListCellProps {
  value: EditableTagListCellValue;
  rowData?: any;
  header?: string;
  onCellValueChange?: (rowData: any, fieldKey: string, newValue: any) => void;
}

const EditableTagListCell: React.FC<EditableTagListCellProps> = (props) => {
  const remountKey = `${props.rowData?.id ?? "row"}-${props.header ?? ""}`;
  return (
    <OasisEditableTagListCell
      key={remountKey}
      value={props.value}
      rowData={props.rowData}
      header={props.header}
      onCellValueChange={props.onCellValueChange}
      maxVisibleTags={props.value.maxVisibleTags}
    />
  );
};

export default EditableTagListCell;
